var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcBrandGooglePlaySolid = function SvgIcBrandGooglePlaySolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.098 2.756Q3 3.034 3 3.401v17.197q.002.369.099.648L12.342 12zM3.8 21.96c.329.094.736.03 1.176-.22l10.907-6.198-2.834-2.833zm12.985-6.93 3.355-1.906c1.086-.618 1.086-1.628 0-2.245l-3.355-1.906L13.756 12zm-.902-6.57L4.976 2.261c-.44-.25-.849-.314-1.178-.22l9.251 9.252z",
    clipRule: "evenodd"
  })));
};
export default SvgIcBrandGooglePlaySolid;